// src/constants/menuLabelMap.js

export const menuLabelMap = {
    '/customers': 'Customers',
    '/pets': 'Pets',
    '/services': 'Services',
    '/groomers': 'Groomers',
    '/users': 'Users',
    '/reports': 'Reports',
  };  